import { ProcessedSearchResultItem } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import { IntlShape } from '@redbubble/next/intl';
import { CarouselMediaCardProps } from 'components/CarouselSection/types';
import { PriceProps } from 'components/Price';
import type { ListsInclusions, RecommendedProduct } from 'types/shop-bff/types';
import { getPreviewUrl } from '../../../../utils/common';
import { PreviewStyle } from '../../../i/constants';
import { messages } from '../messages';

export const mapSimilarProductMediaCardProps = (
  listsInclusions: ListsInclusions | null
) => {
  return (
    inputData: RecommendedProduct,
    intl: IntlShape
  ): CarouselMediaCardProps | null => {
    const inventoryItem = inputData?.inventoryItem;

    if (!inventoryItem || !inventoryItem.productPageUrl) return null;

    const { work } = inventoryItem;
    // TODO: When IHS schema updates, remove nullish option
    const artistName = work.artistShopDisplayName ?? undefined;

    return {
      productId: inventoryItem.id,
      link: new URL(inventoryItem.productPageUrl).pathname,
      imageSrc: getPreviewUrl(inventoryItem, PreviewStyle.CLOSE_PREVIEW),
      title: `${work.title} ${inventoryItem.description}`,
      workTitle: work.title,
      artistName,
      matureContent: work.matureContent,
      caption: intl.formatMessage(messages.byArtist, {
        artistName,
      }),
      tags: work.tags,
      loading: false,
      testId: `similar-products-card`,
      addToListButtonProps: {
        inventoryItem: inventoryItem as ProcessedSearchResultItem,
        workId: work.id,
        listsInclusions,
      },
      stockStatus: inventoryItem.stockStatus,
    };
  };
};

export const mapSimilarProductPriceProps = (
  inputData: RecommendedProduct
): PriceProps | null => {
  if (!inputData?.inventoryItem?.price) return null;

  const { discount, currency, amount } = inputData.inventoryItem.price;

  return {
    discount,
    currency,
    amount,
  };
};
